// Map world-atlas (Natural Earth 110m) country names to the names we use in
// our Territory taxonomy. World-atlas at low resolution abbreviates many
// country names; this table reconciles them.
export const WORLD_ATLAS_NAME_ALIASES: Record<string, string> = {
  'United States of America': 'United States',
  'Russian Federation': 'Russia',
  'Czech Republic': 'Czechia',
  'Republic of Korea': 'South Korea',
  "Democratic People's Republic of Korea": 'North Korea',
  'Dem. Rep. Korea': 'North Korea',
  'Republic of Congo': 'Congo',
  'Dem. Rep. Congo': 'Democratic Republic of the Congo',
  'Democratic Republic of the Congo': 'Democratic Republic of the Congo',
  "Dem. People's Rep. Korea": 'North Korea',
  'Iran (Islamic Republic of)': 'Iran',
  'Islamic Republic of Iran': 'Iran',
  'Syrian Arab Republic': 'Syria',
  "Lao People's Democratic Republic": 'Laos',
  'Lao PDR': 'Laos',
  'Viet Nam': 'Vietnam',
  'Brunei Darussalam': 'Brunei',
  'Cape Verde': 'Cabo Verde',
  'Swaziland': 'Eswatini',
  'Bolivia (Plurinational State of)': 'Bolivia',
  'Venezuela (Bolivarian Republic of)': 'Venezuela',
  'United Republic of Tanzania': 'Tanzania',
  'Bosnia and Herz.': 'Bosnia and Herzegovina',
  'Dominican Rep.': 'Dominican Republic',
  'Eq. Guinea': 'Equatorial Guinea',
  'S. Sudan': 'South Sudan',
  'Central African Rep.': 'Central African Republic',
  'W. Sahara': 'Western Sahara',
  'Falkland Is.': 'Falkland Islands',
  'Solomon Is.': 'Solomon Islands',
  "Côte d'Ivoire": "Côte d'Ivoire",
  'Macedonia': 'North Macedonia',
  'The former Yugoslav Republic of Macedonia': 'North Macedonia',
  'Republic of Moldova': 'Moldova',
  'Republic of Serbia': 'Serbia',
  'Taiwan, Province of China': 'Taiwan',
  'United Kingdom of Great Britain and Northern Ireland': 'United Kingdom',
  'United Republic of Tanzania, the': 'Tanzania',
  'Vatican': 'Vatican City',
  'Holy See': 'Vatican City',
  'Timor-Leste': 'Timor-Leste',
  'East Timor': 'Timor-Leste',
  'Burma': 'Myanmar',
  'Federated States of Micronesia': 'Micronesia',
}

export function normaliseCountryName(name: string): string {
  return WORLD_ATLAS_NAME_ALIASES[name] ?? name
}
